import { Exercise } from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { Mindfulness } from '../../../articles/Mindfulness';

export const exerciseData27: ExerciseData = {
    ExerciseView: Module2Exercise7,
    dataKeys: [],
    questions: [],
};

function Module2Exercise7({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Hvad kan mindfullness?">
            <Mindfulness />
        </Exercise>
    );
}
